import { render, staticRenderFns } from "./DemoI18nControl.vue?vue&type=template&id=457b3e39"
import script from "./DemoI18nControl.vue?vue&type=script&lang=js"
export * from "./DemoI18nControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports